import React from 'react';
import { Mail, FileText } from 'lucide-react';
import { Button } from './ui/button';

const Schools = () => {
  return (
    <section id="schools" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <div className="flex items-center justify-center gap-4 mb-6">
            <img
              src="/kyle-drive-logo.png"
              alt="Kyle Drive"
              className="h-20 w-auto animate-bounce"
              style={{ animationDuration: '2s' }}
            />
            <h2 className="text-4xl lg:text-5xl font-bold text-[hsl(210,100%,12%)]">
              School & Group Bookings
            </h2>
          </div>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            Kyle Drive is a popular choice for school trips, youth groups, and special events. We can accommodate multiple learners in a single session.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-12">
          <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 shadow-lg border-2 border-gray-200">
            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-[hsl(210,100%,45%)] to-[hsl(180,80%,45%)] mb-6 mx-auto">
              <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 14L8 10H16L12 14Z" fill="white"/>
                <rect x="6" y="6" width="12" height="2" fill="white"/>
                <circle cx="12" cy="18" r="2" fill="white"/>
              </svg>
            </div>
            <h3 className="text-xl font-bold text-[hsl(210,100%,12%)] mb-3 text-center">Educational Trips</h3>
            <ul className="space-y-2 text-gray-600 text-center">
              <li>Hands-on road safety learning</li>
              <li>Practical driving skills</li>
              <li>Unique school experience</li>
            </ul>
          </div>

          <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 shadow-lg border-2 border-gray-200">
            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-[hsl(210,100%,45%)] to-[hsl(180,80%,45%)] mb-6 mx-auto">
              <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="9" cy="8" r="2" stroke="white" strokeWidth="2"/>
                <circle cx="15" cy="8" r="2" stroke="white" strokeWidth="2"/>
                <circle cx="12" cy="16" r="2" stroke="white" strokeWidth="2"/>
                <path d="M9 10L12 14M15 10L12 14" stroke="white" strokeWidth="2"/>
              </svg>
            </div>
            <h3 className="text-xl font-bold text-[hsl(210,100%,12%)] mb-3 text-center">Youth Groups</h3>
            <ul className="space-y-2 text-gray-600 text-center">
              <li>Scouts, cadets, sports clubs</li>
              <li>Structured group experience</li>
              <li>Fun team activity</li>
            </ul>
          </div>

          <div className="bg-gradient-to-br from-blue-50 to-white rounded-2xl p-8 shadow-lg border-2 border-gray-200">
            <div className="flex items-center justify-center w-16 h-16 rounded-full bg-gradient-to-br from-[hsl(210,100%,45%)] to-[hsl(180,80%,45%)] mb-6 mx-auto">
              <svg className="w-8 h-8" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M12 2L15 8L22 9L17 14L18 21L12 18L6 21L7 14L2 9L9 8L12 2Z" fill="white"/>
              </svg>
            </div>
            <h3 className="text-xl font-bold text-[hsl(210,100%,12%)] mb-3 text-center">Special Events</h3>
            <ul className="space-y-2 text-gray-600 text-center">
              <li>Birthday celebrations</li>
              <li>Memorable gift experience</li>
              <li>Stand-out occasions</li>
            </ul>
          </div>
        </div>

        <div className="bg-gradient-to-br from-[hsl(210,100%,45%)] to-[hsl(180,80%,45%)] rounded-3xl p-8 md:p-12 text-white shadow-xl">
          <h3 className="text-2xl font-bold mb-4">Group Booking Enquiries</h3>
          <p className="text-lg mb-8 leading-relaxed">
            We offer flexible packages for schools, youth groups, and celebrations. Get in touch to discuss availability and custom pricing.
          </p>
          
          <div className="grid sm:grid-cols-2 gap-4">
            <a href="mailto:groups@kyledrive.co.uk" className="block">
              <Button 
                variant="secondary"
                className="w-full bg-white text-[hsl(210,100%,45%)] hover:bg-gray-100 font-semibold py-6 text-base"
              >
                <Mail className="w-5 h-5 mr-2" />
                Email Us
              </Button>
            </a>
            
            <a href="mailto:groups@kyledrive.co.uk" className="block">
              <Button 
                variant="secondary"
                className="w-full bg-white text-[hsl(210,100%,45%)] hover:bg-gray-100 font-semibold py-6 text-base"
              >
                <FileText className="w-5 h-5 mr-2" />
                Schools & Group Enquiries
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Schools;